import * as React from "react";
import { useContext } from "react";
import FieldSelectBase from "views/components/aggregationwizard/FieldSelectBase";
import FieldTypesContext from "views/components/contexts/FieldTypesContext";
const FieldSelect = (props) => {
  var _a, _b;
  const fieldTypes = useContext(FieldTypesContext);
  const fieldOptions = (_b = (_a = fieldTypes.currentQuery) == null ? void 0 : _a.toArray()) != null ? _b : [];
  return /* @__PURE__ */ React.createElement(FieldSelectBase, { options: fieldOptions, ...props });
};
export default FieldSelect;
